import { EmailUseScreenComponent } from '../../../../components/screens/signup-process/email-use-screen/email-use-screen.component';
import { EmailErrorSvgComponent } from '../../../../modules/mapfre-design-library/src/lib/svg/email-error-svg/email-error-svg.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, EmailErrorSvgComponent, EmailUseScreenComponent],
  selector: 'app-signup-email-in-use',
  templateUrl: './signup-email-in-use.component.html',
})
export class SignupEmailInUseComponent{
  
}
